import { render, staticRenderFns } from "./StatsValue.vue?vue&type=template&id=5eaaed07&scoped=true&"
import script from "./StatsValue.vue?vue&type=script&lang=js&"
export * from "./StatsValue.vue?vue&type=script&lang=js&"
import style0 from "./StatsValue.vue?vue&type=style&index=0&id=5eaaed07&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eaaed07",
  null
  
)

export default component.exports